import { DARK_THEME_PAGES } from '@creditflowresearch/config/themeConfig';
import { DARK_THEME_ENABLED } from '@creditflowresearch/config/featureToggle';

const isServer = typeof document === 'undefined';

// TODO: dark-theme — remove once all pages support dark theme.

export const isDarkThemePage = (path: string): boolean => {
  const pathWithoutQuery = path.split('?')[0];

  return DARK_THEME_PAGES.some((page) => pathWithoutQuery.startsWith(page));
};

/** Full-width popup paths always have dark theme enabled (no feature toggle required). */
const isFullWidthPath = (path: string): boolean => {
  return path.split('?')[0].includes('/full-width');
};

/** Checks if dark theme feature flag is enabled via cookies. */
const isFeatureEnabled = (cookies?: Record<string, string>): boolean => {
  // On SSR, use provided cookies from the request
  if (isServer) {
    return Boolean(cookies?.[DARK_THEME_ENABLED]);
  }

  // On client, always read from document.cookie (fresh value)
  const parsedCookies = document.cookie.split('; ').reduce<Record<string, string>>((acc, cookie) => {
    const [key, value] = cookie.split('=');
    acc[key] = value;

    return acc;
  }, {});

  return Boolean(parsedCookies[DARK_THEME_ENABLED]);
};

export const isDarkThemeSupported = (
  path: string,
  cookies?: Record<string, string>,
): boolean => {
  if (isFullWidthPath(path)) {
    return isDarkThemePage(path);
  }

  return isDarkThemePage(path) && isFeatureEnabled(cookies);
};
